export default __webpack_public_path__ + "static/media/chevron-left-gray.8cbd0d4a.svg";